import { Controller } from "@hotwired/stimulus"

// Tech-support widget: a floating headphones button that opens a small popup
// listing who to contact for help (email + phone). Uses the native <dialog>
// element so focus trapping, Esc-to-close, and the backdrop come for free.
// Wire-up:
//   data-controller="support"
//   <button data-action="support#open">           … the floating button
//   <dialog data-support-target="dialog">          … the popup
//   <button data-action="support#close">           … any close control inside
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // Close when the click lands on the ::backdrop (outside the dialog's box).
  backdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
